"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function openVideo(event) {
  var modal = document.getElementById('js-modal-video');
  var iframe = modal.querySelector('iframe');
  var src = 'https://www.youtube.com/embed/' + event.srcElement.dataset.id + '?autoplay=1&enablejsapi=1';
  iframe.src = src;
  modal.classList.add('is-open');
}

function closeModal(id) {
  var modal = document.getElementById(id);
  var iframe = modal.querySelector('iframe');
  iframe.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
  modal.classList.remove('is-open');
}

var GermanSlider =
/*#__PURE__*/
function () {
  function GermanSlider(slider) {
    _classCallCheck(this, GermanSlider);

    console.log('here');
    this.container = slider;
    this.controllers = _toConsumableArray(this.container.querySelectorAll('.js-controller'));
    this.list = this.container.querySelector('.js-knowledges');
    this.elements = _toConsumableArray(this.list.querySelectorAll('li'));
    this.index = 0;
    this.step = this.elements[0].offsetWidth;
    this.listen();
  }

  _createClass(GermanSlider, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.controllers.forEach(function (control) {
        control.addEventListener('click', function () {
          control.classList.contains('prev') ? _this.prev() : _this.next();
        });
      });
    }
  }, {
    key: "prev",
    value: function prev() {
      this.index = this.index - 1 >= 0 ? this.index - 1 : this.elements.length - 1;
      this.slide();
    }
  }, {
    key: "next",
    value: function next() {
      this.index = (this.index + 1) % this.elements.length;
      this.slide();
    }
  }, {
    key: "slide",
    value: function slide() {
      this.list.style.transform = "translateX(-".concat(this.index * this.step, "px)");
      this.list.style.msTransform = "translateX(-".concat(this.index * this.step, "px)");
      this.list.style.webkitTransform = "translateX(-".concat(this.index * this.step, "px)");
    }
  }]);

  return GermanSlider;
}();

window.addEventListener("DOMContentLoaded", function () {
  var sliders = document.getElementsByClassName('js-slider');
  Array.from(sliders).forEach(function (slider) {
    return new GermanSlider(slider);
  });
});